// import React from 'react';
import {
  Business as BusinessIcon,
  TrendingUp as GrowthIcon,
  AttachMoney as MoneyIcon,
  Security as SecurityIcon,
  Store as StoreIcon,
  School as SchoolIcon,
  Smartphone as MobileIcon,
  Group as UsersIcon,
  Lightbulb as LightbulbIcon,
  LocalShipping as TruckIcon,
  Chat as ChatIcon,
  Restaurant as UtensilsIcon,
  ShoppingCart as ShoppingCartIcon
} from '@mui/icons-material';

// Custom icon components
export const BusinessOperationsIcon = BusinessIcon;
export const GrowthScalingIcon = GrowthIcon;
export const FundingIcon = MoneyIcon;
export const RegulatoryIcon = SecurityIcon;
export const KitchenIcon = StoreIcon;
export const TrainingIcon = SchoolIcon;
export const DigitalIcon = MobileIcon;
export const CommunityIcon = UsersIcon;
export const DreamIcon = LightbulbIcon;
export const SupplyIcon = TruckIcon;
export const FeedbackIcon = ChatIcon;
export const HomeCookIcon = UtensilsIcon; 
export const GroceryShoppingIcon = ShoppingCartIcon;